import { QrCode2, ContentCopy, Close } from "@mui/icons-material";
import {
  IconButton,
  Dialog,
  Box,
  Container,
  Link,
  Button,
  Typography,
  Tooltip,
  DialogContent,
  DialogActions,
  DialogTitle,
} from "@mui/material";
import { useState } from "react";
import QRCode from "qrcode.react";
function QrCodeDialog({ url = "", children, title = "Código QR" }) {
  const [linkDialog, setLinkDialog] = useState(false);
  const handleCloseDialog = () => {
    setLinkDialog(false);
  };
  const handleOpenDialog = () => {
    setLinkDialog(true);
  };

  const methods = {
    openDialog: handleOpenDialog,
    closeDialog: handleCloseDialog,
  };
  return (
    <>
      <Tooltip title="Ver código QR">{children(methods)}</Tooltip>
      <Dialog
        open={linkDialog}
        onClose={handleCloseDialog}
        maxWidth={"sm"}
        fullWidth
      >
        <DialogTitle>{title}</DialogTitle>
        <IconButton
          onClick={handleCloseDialog}
          sx={{ position: "absolute", top: 3, right: 3 }}
        >
          <Close />
        </IconButton>
        <DialogContent
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <QRCode value={url} />

          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              width: "100%",
              overflow: "hidden",
            }}
          >
            <IconButton
              sx={{ display: "flex", flexDirection: "column" }}
              onClick={() => {
                navigator.clipboard.writeText(url);
              }}
            >
              <Typography sx={{ fontSize: "0.7rem" }}>Copiar</Typography>

              <ContentCopy />
            </IconButton>
            <Link
              sx={{
                padding: "12px",
                overflow: "hidden",
                width: "100%",
                whiteSpace: "nitial",
                wordWrap: "break-word",
              }}
              variant="link"
              href={url}
              target="_blank"
            >
              {url}
            </Link>
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
}

export default QrCodeDialog;
